// 2026-10-13 零售包裹(收发货管理 → 待发货 / 已发货 · 第十五轮)
export default {
  "按销售单重新拆包?这张单所有待配货的包裹会删掉重拆。": "Re-split from the sales order? All to-pack parcels of this order will be deleted and re-created.",
  "包裹": "Parcel",
  "包裹 {k}": "Parcel {k}",
  "编辑收货 / 申报": "Edit receiver / customs",
  "编辑 {no}": "Edit {no}",
  "标签": "Tags",
  "补出库号": "Attach outbound no.",
  "查智邦": "Look up in Zhibang",
  "拆": "Split",
  "拆包": "Split parcel",
  "拆包裹": "Parcel split",
  "拆包 {no}": "Split {no}",
  "拆成": "Split into",
  "撤销手填的 {carrier} 运单 {wb}?": "Remove the manually entered {carrier} waybill {wb}?",
  "撤销手填运单": "Remove manual waybill",
  "撤销云途单": "Cancel YunExpress order",
  "撤销云途单 {wb}?撤销后包裹回到待配货,可以改了再下。": "Cancel YunExpress order {wb}? The parcel goes back to To pack so you can edit and re-order.",
  "城市": "City",
  "成品+配件": "Product + accessories",
  "出货单(B2B)": "Shipments (B2B)",
  "出库日期": "Outbound date",
  "纯配件": "Accessories only",
  "打开面单": "Open label",
  "打印面单": "Print labels",
  "打印清单": "Print sheet",
  "打印 {n} 次": "Printed {n}×",
  "待出账": "Not billed yet",
  "待配货": "To pack",
  "待填": "To fill",
  "单件重量 g": "Unit weight (g)",
  "到对应公司的「销售订单」补产品 / 来货价后点「推给下游」": "Fix products / cost prices in that company's Sales orders, then click Push downstream",
  "地址第二行": "Address line 2",
  "第 {k} 包": "Parcel {k}",
  "二字码或国名": "ISO code or country name",
  "改备注": "Note changed",
  "改标签": "Tags changed",
  "改出库 SKU": "Change outbound SKU",
  "改申报": "Customs edited",
  "改收货": "Receiver edited",
  "改用其他快递": "Use another carrier",
  "个包裹 · 每一行分到各包裹的数量加起来要等于原数量": "parcels · quantities per line must add up to the original",
  "共 {n} 张订单": "{n} orders",
  "勾待配货的包裹": "Select To-pack parcels",
  "勾同一张订单的 2 个以上待配货包裹": "Select 2+ To-pack parcels of the same order",
  "勾已下云途的包裹": "Select parcels already ordered with YunExpress",
  "挂上": "Attach",
  "❌ 还不能切": "❌ Not ready to switch",
  "合包": "Merge parcels",
  "合进别的包裹": "Merged into another parcel",
  "换渠道": "Channel changed",
  "近 {d} 天 {n} 张单,{r} 张推到了发货公司": "Last {d} days: {n} orders, {r} reached the shipping company",
  "看是哪些": "Show",
  "✅ 可以切": "✅ Ready to switch",
  "空 = 墨西哥 / 挪威自动填": "Empty = auto-filled for Mexico / Norway",
  "空 = 欧盟单用默认 IOSS": "Empty = default IOSS for EU orders",
  "快递公司": "Carrier",
  "拉面单": "Fetch label",
  "零售包裹出面单": "Retail parcel labels",
  "零售包裹在 ERP「收发货管理 → 待发货」出面单": "Retail parcel labels are made in ERP Shipping → To ship",
  "没有包裹 · 在「操作」里点「重新拆包」": "No parcels · use Actions → Re-split",
  "点单号看时间轴": "Click the order number to see its timeline",
  "订单商品": "Order items",
  "链路单号": "Chain orders",
  "IOSS / 税号": "IOSS / Tax ID",
  "从中间件迁入": "Migrated from middleware",
  "从中间件改到 ERP 发": "Moved from middleware to ERP shipping",
  "销售单自动确认 · 转待发货": "Sales order auto-confirmed · awaiting shipment",
  "重新拆包(整单)": "Re-split (whole order)",
  "面单": "Label",
  "内容": "Contents",
  "切到 ERP 后:新单在「收发货管理 → 待发货」出云途面单、智邦出库,整单发完回传链路和平台;已经在中间件里的单在中间件发完。": "After switching to ERP: new orders get YunExpress labels and Zhibang outbound in Shipping → To ship; when a whole order ships it is synced up the chain and to the platform. Orders already in the middleware finish there.",
  "切店前检查": "Pre-switch check",
  "渠道 / 运单": "Channel / waybill",
  "全部店铺": "All stores",
  "确认日期": "Confirmed",
  "上游还有 {n} 张单没推到发货公司,这些单在这里发不出去": "{n} upstream orders have not reached the shipping company and can't be shipped here",
  "申报": "Customs",
  "申报价值 $": "Declared value $",
  "省州": "State / province",
  "时间轴": "Timeline",
  "时间轴 · {no}": "Timeline · {no}",
  "是": "Yes",
  "收件人": "Recipient",
  "收起": "Hide",
  "搜平台单号 / 收件人 / SKU / 包裹号 / 运单号 / 出库单": "Search platform order / recipient / SKU / parcel / waybill / outbound",
  "填数字": "Enter a number",
  "填完照常点「智邦出库」· 运费不知道可以以后在「操作 → 填运费」补": "Then click Zhibang outbound as usual · freight can be filled later via Actions → Fill freight",
  "填运费": "Fill freight",
  "下云途": "Order YunExpress",
  "下 {n} 个包裹到云途(会真的生成运单)?": "Order {n} parcels with YunExpress (real waybills will be created)?",
  "下 {n} 个包裹到云途沙箱(测试,不会真发)?": "Order {n} parcels in the YunExpress sandbox (test only, nothing ships)?",
  "先勾包裹": "Select parcels first",
  "显示作废的": "Show voided",
  "一件代发中间件(现状)": "Dropshipping middleware (current)",
  "已拆成 {n} 个包裹": "Split into {n} parcels",
  "已出库": "Out of warehouse",
  "已出库 {a}/{b}": "Out {a}/{b}",
  "已出库 {n} 个 · 整单发完 {m} 张": "{n} parcels out · {m} orders fully shipped",
  "已改用 {carrier}": "Switched to {carrier}",
  "已勾 {n} 个包裹": "{n} parcels selected",
  "已挂上出库单 {ck}": "Outbound {ck} attached",
  "已下云途": "Ordered",
  "已下云途 {n} 个": "{n} ordered with YunExpress",
  "英文申报名": "English customs name",
  "用逗号隔开,最多 8 个": "Comma-separated, up to 8",
  "有": "Yes",
  "有没有": "Exists",
  "云途沙箱 · 测试,不会真发": "YunExpress sandbox · test only, nothing ships",
  "云途下单失败": "YunExpress order failed",
  "运费(元)": "Freight (CNY)",
  "这张订单其他待配货的包裹一起改": "Also update this order's other To-pack parcels",
  "整单发货 · 回传链路": "Order shipped · synced up the chain",
  "智邦出库": "Zhibang outbound",
  "智邦出库失败": "Zhibang outbound failed",
  "智邦出库用的 SKU(云途申报不变)": "SKU for Zhibang outbound (YunExpress customs unchanged)",
  "智邦出库 SKU": "Outbound SKU",
  "智邦登录失效 · 到中间件刷新": "Zhibang login expired · refresh it in the middleware",
  "智邦登录有效": "Zhibang login OK",
  "智邦里没有这张出库单": "No such outbound in Zhibang",
  "智邦里已经有这个包裹的出库单(手工建的,或者出库「结果不明」其实建成了)→ 挂上就当出库了,不会再建一张": "Zhibang already has this parcel's outbound (made by hand, or an \"unknown result\" that actually succeeded) → attach it to count as shipped without creating another",
  "中间件智邦自动出库没开": "Middleware Zhibang auto-outbound is off",
  "中文申报名": "Chinese customs name",
  "重新拆包": "Re-split",
  "作废包裹 {no}": "Void parcel {no}",
  "{carrier} 运费(元)": "{carrier} freight (CNY)",
  "ERP 出面单": "ERP labels",
  "ERP 收发货管理": "ERP Shipping",
  "{label}完成": "{label} done",
  "{n} 个包裹在智邦出库(扣添来仓库存)?整张订单的包裹都出完会自动回传链路、开票。": "Create Zhibang outbounds for {n} parcels (deducts Tianlai warehouse stock)? When all parcels of an order are out, it is synced up the chain and invoiced.",
  "{ok} 个成功 · {n} 个没成": "{ok} succeeded · {n} failed",
  // 店铺出面单(切店 · 发货公司切)
  "店铺出面单": "Store labels",
  "本公司还没开通零售包裹发货(没有云途账号)": "Retail parcel shipping isn't set up for this company (no YunExpress account)",
  "集团的零售包裹现在由「{name}」在它的「收发货管理 → 待发货」里发。": "The group's retail parcels are currently shipped by \"{name}\" from its Shipping → To ship page.",
  "本公司要自己发零售包裹:到「外部平台」新建一个「云途物流」账号,这里就能下云途、打面单、智邦出库。": "To ship retail parcels from this company, add a YunExpress account under External Platforms. You can then book YunExpress, print labels and post Zhibang outbound here.",
  "去外部平台 →": "Go to External Platforms →",
  "出面单": "Labels by",
  "这里(ERP)": "Here (ERP)",
  "切到这里": "Switch here",
  "切回中间件": "Back to middleware",
  "已切到这里出面单": "Switched: labels now printed here",
  "已切回中间件": "Switched back to middleware",
  "只有公司管理员能切。": "Only company admins can switch.",
  "把「{store}」切到这里出面单?切过去以后这个店的新单在「待发货」里下云途、智邦出库;已经在中间件里的单在中间件发完。": "Print labels for \"{store}\" here? New orders from this store will be booked with YunExpress and shipped out of Zhibang under Awaiting Shipment; orders already in the middleware are finished there.",
  "把「{store}」切回一件代发中间件?之后的新单回到中间件发;这里已经拆好的包裹不受影响,要在这里发完。": "Move \"{store}\" back to the middleware? New orders will ship from the middleware again; parcels already created here stay and must be finished here.",
  "集团里各公司的 Etsy / Shopify / 亚马逊店,零售包裹在哪出面单。上游公司只管把单推给下游,谁来发由这里定。": "Where each group company's Etsy / Shopify / Amazon store prints retail parcel labels. Upstream companies just push orders downstream; the shipper decides here.",
  "切到这里之前先做「切店前检查」(近 30 天的单都推到了这里才让切)。亚马逊店只进自发货单(FBA 不进),拿不到买家地址的包裹标「缺收货地址」。": "Run the pre-switch check first (all orders of the last 30 days must have reached us). Amazon stores bring in merchant-fulfilled orders only (not FBA); parcels without the buyer's address are tagged \"缺收货地址\" (missing address).",
  "零售包裹由发货公司在 ERP「收发货管理 → 待发货」出面单": "Retail parcel labels are printed by the shipping company in ERP (Shipments → Awaiting Shipment)",
  "发货公司 ERP「收发货管理」": "Shipping company's ERP (Shipments)",
  "谁来打面单由发货公司定:在发货公司「收发货管理 → 待发货 → 店铺出面单」里切。这里只要把单推给下游就行。": "The shipping company decides who prints labels (Shipments → Awaiting Shipment → Store labels there). This company only needs to push orders downstream.",
  "零售包裹拆包用:配件不单独占一个包裹,跟同一张单的第一个成品包裹一起寄;一张单只有配件时单独一个包裹。": "For retail parcel splitting: an accessory doesn't get its own parcel; it ships with the order's first product parcel. An order with only accessories gets one parcel.",
  "只看配件": "Accessories only",
  // 2026-10-19 防打重
  "面单没打过": "Label never printed",
  "面单打过": "Label printed",
  "清单没打过": "Packing slip never printed",
  "清单打过": "Packing slip printed",
  "Excel 没导过": "Excel never exported",
  "Excel 导过": "Excel exported",
  "清单": "Packing slip",
  "{what}还没打过": "{what} not printed yet",
  "{what}打过 {n} 次": "{what} printed {n} times",
  "最后一次 {t} {by}": "last {t} {by}",
  "勾的 {n} 个包裹里有 {m} 个{what}已经打过(最多 {max} 次):{nos}。确定再来一次?": "{m} of the {n} selected parcels already have their {what} done (up to {max} times): {nos}. Do it again?",
  "可能打重": "Possible duplicate",
  "确定再打": "Do it again",
  "打印状态": "Print status",
  // 2026-10-20 零售包裹:已下云途改收货 / 申报(只改记录 · 改完重新下单)· 已出库改运单号
  "收货和申报都没改,不用重新下云途单(只改出库 SKU 点「只改记录」)": "Neither the receiver nor the declaration changed, so no need to re-place the YunExpress order (to change only the outbound SKU, click “Record only”)",
  "撤销云途单 {wb},改好后重新下单?会拿到新运单号和新面单,旧面单作废,已经打印的要换掉。": "Cancel YunExpress order {wb} and place it again after the changes? You will get a new waybill and a new label; the old label becomes invalid, so replace any printed copy.",
  "改完重新下云途单": "Save & re-place YunExpress order",
  "旧单已撤销、改好了,但重新下云途单失败:{err} · 包裹回到待配货,处理后再点「下云途」": "The old order was cancelled and the changes saved, but re-placing the YunExpress order failed: {err} · The parcel is back to “To pick”; fix it and click “Place YunExpress”",
  "已重新下云途单:新运单号 {wb}": "YunExpress order re-placed: new waybill {wb}",
  "已保存 · 只改了 ERP 记录,云途单和面单没变": "Saved · only the ERP record changed; the YunExpress order and label are unchanged",
  "已改成 {wb}": "Changed to {wb}",
  "销售单一起改了:{list}": "Sales orders updated too: {list}",
  "新面单在「操作 → 拉面单」": "Get the new label via “Actions → Fetch label”",
  "修改收货 / 申报 / 出库 SKU": "Edit receiver / declaration / outbound SKU",
  "改运单号 / 快递": "Change waybill / carrier",
  "已填 {carrier} 运单 {wb}:只能「只改记录」(只改 ERP,运单不变)": "{carrier} waybill {wb} already filled in: only “Record only” is available (changes the ERP record; the waybill stays)",
  "已下云途 {wb}:「只改记录」只改 ERP,云途单和面单不变;「改完重新下云途单」会撤销旧单、改好后重新下单,拿新运单号和新面单": "YunExpress order {wb} placed: “Record only” changes just the ERP record (YunExpress order and label unchanged); “Save & re-place” cancels the old order and places a new one after the changes, with a new waybill and label",
  "这张订单其他还没出库的包裹一起改": "Also update this order's other parcels that haven't shipped",
  "申报 / 智邦出库 SKU": "Declaration / Zhibang outbound SKU",
  "只改记录": "Record only",
  "改运单号 / 快递 {no}": "Change waybill / carrier {no}",
  "只改 ERP 记录:智邦出库单不变;链路上各家销售单记的旧单号一起改。平台(Etsy / Shopify / 亚马逊)上已经回传的运单号不会跟着改,要去平台上手改。": "Changes the ERP record only: the Zhibang outbound note stays; the old waybill on every sales order in the chain is updated too. Tracking already sent to the platform (Etsy / Shopify / Amazon) is NOT updated — change it on the platform by hand.",
  "云途 / DHL / UPS …": "YunExpress / DHL / UPS …",
  "原来:{carrier} {wb}": "Was: {carrier} {wb}",
  "云途": "YunExpress",
  // 2026-10-20 云途揽收预报
  "揽收预报": "Pickup request",
  "推荐": "recommended",
  "选揽收地址": "Pick a pickup address",
  "选期望时段": "Pick a time window",
  "填预估重量": "Enter the estimated weight",
  "已预报揽收 · 揽收单 {no}": "Pickup requested · pickup no. {no}",
  "已预报揽收": "Pickup requested",
  "这天已有待揽收的单,还要再报一张吗?": "There's already a pending pickup that day. Request another one?",
  "已有揽收单": "Pickup already exists",
  "预报失败": "Request failed",
  "选取消原因": "Pick a cancel reason",
  "取消失败": "Cancel failed",
  "云途揽收预报": "YunExpress pickup request",
  "中间件的云途后台登录失效": "The middleware's YunExpress portal login has expired",
  "揽收预报经一件代发中间件提交:到中间件「系统设置 → 云途后台登录」重新粘贴 cookie 后再试。": "Pickup requests go through the dropship middleware: paste the cookie again in the middleware's \"System → YunExpress portal login\", then retry.",
  "今天下了云途单的包裹 {n} 个 · 约 {kg} kg": "Parcels with YunExpress orders today: {n} · about {kg} kg",
  "(其中已智邦出库 {m} 个)": "({m} already out of Zhibang stock)",
  "最近的揽收单(昨天和今天建的)": "Recent pickups (created yesterday and today)",
  "没有": "None",
  "揽收单号": "Pickup no.",
  "期望揽收": "Requested pickup",
  "袋 / 件(预报 / 实际)": "Bags / parcels (requested / actual)",
  "重量 kg": "Weight kg",
  "司机": "Driver",
  "已分配": "Assigned",
  "未分配": "Not assigned",
  "新建揽收预报": "New pickup request",
  "揽收地址": "Pickup address",
  "期望日期": "Date",
  "非快件": "Non-express",
  "快件": "Express",
  "期望时段": "Time window",
  "开始": "Start",
  "结束": "End",
  "这天没有可约的时段": "No time windows available that day",
  "袋数 / 包裹数": "Bags / parcels",
  "预估重量 kg": "Est. weight kg",
  "选填 · 给司机看": "Optional · for the driver",
  "取消揽收 {no}": "Cancel pickup {no}",
  "取消原因": "Cancel reason",
  "不取消": "Keep it",
  "取消揽收": "Cancel pickup",
  "提交揽收预报": "Submit pickup request",
  "已改成明天": "switched to tomorrow",
  "勾的 {n} 个包裹里有 {m} 个已经导出过 Excel(最多 {max} 次):{nos}。确定再导出一次?": "{m} of the {n} selected parcels have already been exported to Excel (up to {max} times): {nos}. Export again?",
  "可能重复导出": "Possible duplicate export",
  "确定再导出": "Export again",
  "还没导出过 Excel": "Not exported to Excel yet",
  "Excel 导出过 {n} 次": "Exported to Excel {n} times",
  "不设:零售包裹按老规则在智邦「木制品成品仓（添来仓）」出库,发货单扣默认仓。确定?": "Not set: retail parcels ship out of Zhibang \"Wooden Finished Goods (Tianlai)\" as before, and shipments deduct the default warehouse. Continue?",
  "零售包裹在智邦出库(ERP 不另扣,每 30 分钟按智邦对齐);发货单没单独选仓时也落到「{wh}」(不另扣)。确定?": "Retail parcels ship out in Zhibang (ERP doesn't deduct separately; aligned with Zhibang every 30 min). Shipments without their own warehouse also use \"{wh}\" (no separate deduction). Continue?",
  "零售包裹不再经智邦出库,点「出库」时 ERP 直接扣「{wh}」;发货单没单独选仓时也扣它。确定?": "Retail parcels will no longer go through Zhibang; clicking \"Ship out\" deducts \"{wh}\" in ERP directly. Shipments without their own warehouse deduct it too. Continue?",
  "发货出库仓": "Ship-from warehouse",
  "推单只记账,不扣库存;库存由最后真正发货的公司扣,从哪个仓扣在下面「发货出库仓」里选。": "Pushing orders only books the transactions and doesn't touch stock; stock is deducted by the company that actually ships, from the warehouse chosen under \"Ship-from warehouse\" below.",
  "本公司发货时从哪个仓扣库存(零售包裹 + 发货单)": "Which warehouse stock is deducted from when this company ships (retail parcels + shipments)",
  "出库仓": "Ship-from warehouse",
  "不设(老规则)": "Not set (old rule)",
  "零售包裹现在:": "Retail parcels now: ",
  "选关联了智邦的仓 → 零售包裹在智邦建出库单,ERP 不另扣(每 30 分钟按智邦对齐)· 选 ERP 自己的仓 → 不经智邦,ERP 直接扣这个仓。": "Pick a Zhibang-linked warehouse → retail parcels create outbound orders in Zhibang and ERP doesn't deduct separately (aligned with Zhibang every 30 min) · Pick an ERP-only warehouse → skip Zhibang, ERP deducts that warehouse directly.",
  "发货单(B2B)建单时可以单独选仓,没选的从这里扣;落到关联了智邦 / 亚马逊的仓不另扣(以外部平台为准)。": "B2B shipments can pick their own warehouse when created; otherwise they deduct from here. Warehouses linked to Zhibang / Amazon aren't deducted separately (the external platform is the source of truth).",
  "仓库要关联智邦:到【库存台账 → 仓库管理】编辑仓库,「智邦仓库 ID」填 55(只有发货公司能关联)。": "To link a warehouse to Zhibang: Inventory ledger → Warehouses, edit it and set \"Zhibang warehouse ID\" to 55 (only the shipping company can link).",
  "还没有仓库关联智邦": "No warehouse linked to Zhibang yet",
  "{wh} · 跟智邦同步 · 数据时间 {t}": "{wh} · synced with Zhibang · data as of {t}",
  "{wh} 还没同步过智邦": "{wh} hasn't synced with Zhibang yet",
  "关联后「{me}」的数以智邦为准:每 30 分钟按智邦对齐,ERP 的发货单出库 / 采购收货不再往这个仓记账。": "After linking, Zhibang is the source of truth for \"{me}\": it's aligned with Zhibang every 30 min, and ERP shipments / PO receipts no longer post to it.",
  "原来关联智邦的「{old}」会把每个产品的数转到这个仓(记调拨流水),然后清零归档。": "\"{old}\", currently linked to Zhibang, will transfer each product's quantity to this warehouse (as transfer entries), then be zeroed and archived.",
  "取消关联后「{me}」不再跟智邦对齐,现有的数留着,以后由 ERP 自己记账。": "After unlinking, \"{me}\" stops aligning with Zhibang; current quantities stay and ERP keeps its own books from now on.",
  "关联智邦仓库": "Link Zhibang warehouse",
  "取消关联智邦": "Unlink Zhibang",
  "已从 {from} 转过来 {n} 个产品的数 · {from} 已归档": "Transferred quantities of {n} products from {from} · {from} archived",
  "外部仓": "External warehouse",
  "ERP 自己记账": "ERP-managed",
  "智邦仓库 ID": "Zhibang warehouse ID",
  "填 55 = 关联智邦「木制品成品仓（添来仓）」:这个仓的数以智邦为准,每 30 分钟对齐,ERP 的发货单 / 采购收货不往里记账;原来关联的仓会把数转过来并归档。空 = 不关联,ERP 自己记账。只有发货公司能关联。": "55 = link to Zhibang \"Wooden Finished Goods (Tianlai)\": Zhibang is the source of truth, aligned every 30 min, and ERP shipments / PO receipts don't post to it; the previously linked warehouse transfers its quantities here and is archived. Empty = not linked, ERP-managed. Only the shipping company can link.",
  "按系统设置「发货出库仓」": "Per settings \"Ship-from warehouse\"",
  "发出(在途)时从这个仓扣库存 · 关联了智邦的仓以智邦为准,ERP 不另扣": "Stock is deducted from this warehouse when shipped (in transit) · Zhibang-linked warehouses follow Zhibang, ERP doesn't deduct separately",
  "{n} 个包裹出库,ERP 直接扣「{wh}」?整张订单的包裹都出完会自动回传链路、开票。": "Ship out {n} parcels and deduct \"{wh}\" in ERP? When all parcels of an order are out, the chain is updated and invoiced automatically.",
  "出库(ERP 扣仓)": "Shipped out (ERP warehouse)",
  "出库仓:{wh}": "Ship-from: {wh}",
  "ERP 扣仓出库": "Shipped from ERP warehouse",
  "另有 {n} 张亚马逊自发货等的单链路没推下去(不在这里发,只影响集团内记账 / 开票)": "Plus {n} orders (Amazon FBM etc.) not pushed down the chain (not shipped here; only affects intercompany bookkeeping / invoices)",
  "链路没推下去 · 只影响记账 / 开票": "Not pushed down the chain · only affects bookkeeping / invoices",
  "已发货 · 要手动推": "Shipped · push manually",
  "还没发": "Not shipped",
  "还没发的补好后每 30 分钟自动重推;已发货的不会自动推,要手动点": "Unshipped orders are re-pushed every 30 minutes once fixed; shipped ones are not, push them manually",
};
